/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useParams } from "react-router-dom";
import ChecklistDetails from "./components/ChecklistDetails";
import { useQuery } from "@tanstack/react-query";
import { getQuestionById } from "@/lib/services/questions";
import ChecklistIdHeader from "./components/ChecklistIdHeader";
import QuestionsTable from "./components/questions-table/QuestionsTable";
import { useEffect } from "react";
import { useQuestionsForm } from "@/store/useQuestionsForm";
import { useLoader } from "@/context/loader-context/LoaderContext";
import { appToast } from "@/lib/toast";

const ChecklistId = () => {
  const { checklistId } = useParams() as { checklistId: string };
  const translate = useTranslate();
  const { setQuestions, clear } = useQuestionsForm();
  const { showLoader, hideLoader } = useLoader();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["checklistId", checklistId],
    queryFn: () => getQuestionById(checklistId),
  });

  useEffect(() => {
    if (isError) {
      appToast.error(translate("error"), error.message);
    }
  }, [isError, error]);

  useEffect(() => {
    if (data) {
      setQuestions(data.questions);
    }
  }, [data]);

  useEffect(() => {
    if (isLoading) {
      showLoader();
    } else {
      hideLoader();
    }

    return () => {
      hideLoader();
    };
  }, [isLoading]);

  useEffect(() => {
    return () => {
      clear();
    };
  }, []);

  return (
    <div
      data-testid="checklist-view"
      className="overflow-y-auto fle-1 py-[24px] px-[50px]"
    >
      <h1 className="font-ib-bold text-[24px] leading-[150%]">
        {translate("checklist")} {checklistId}
      </h1>
      {data && (
        <div className="space-y-4">
          <ChecklistIdHeader checklist={data} />
          <ChecklistDetails checklist={data} />
          <QuestionsTable />
        </div>
      )}
    </div>
  );
};

export default ChecklistId;
